/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CaretContainer_viewer$ref } from "./CaretContainer_viewer.graphql";
import { ReactionButtonContainer_viewer$ref } from "./ReactionButtonContainer_viewer.graphql";
import { ReportButtonContainer_viewer$ref } from "./ReportButtonContainer_viewer.graphql";
import { UsernameWithPopoverContainer_viewer$ref } from "./UsernameWithPopoverContainer_viewer.graphql";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "%future added value";
declare const _CommentContainer_viewer$ref: unique symbol;
export type CommentContainer_viewer$ref = typeof _CommentContainer_viewer$ref;
export type CommentContainer_viewer = {
    readonly id: string;
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly ignoredUsers: ReadonlyArray<{
        readonly id: string;
    }>;
    readonly badges: ReadonlyArray<string> | null;
    readonly role: USER_ROLE;
    readonly scheduledDeletionDate: string | null;
    readonly " $fragmentRefs": UsernameWithPopoverContainer_viewer$ref & ReactionButtonContainer_viewer$ref & ReportButtonContainer_viewer$ref & CaretContainer_viewer$ref;
    readonly " $refType": CommentContainer_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "CommentContainer_viewer",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "status",
                "storageKey": null,
                "args": null,
                "concreteType": "UserStatus",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "current",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "ignoredUsers",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "badges",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "scheduledDeletionDate",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ReportButtonContainer_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CaretContainer_viewer",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = 'de238a563e1e77572c8fa9b5a7e2e577';
export default node;
